import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { fetchTransportUnitRemaining } from "../../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { PopUpForm } from "../../../../../common/popup/popUpForm/popUpForm";
import { validateDefaultForm } from "../../../utils/utils";
import { MasterSealTypesForm } from "./form/form";

import { PopUpCodes } from "../../../../../../common/enum/PopUpCodes";
import { postToMasterTransportUnitForm } from "../../../../../../redux/actions/resources/master/transportUnit/transportUnit";
import { setShowPopUpMaster } from "../../../../../../redux/reducers/resources/master/master";
import { resetMasterTransportUnitForm } from "../../../../../../redux/reducers/resources/master/transportUnit/form";
import { RequiredFieldsMessage } from "../../../../../common/requiredMessage/requiredMessage";
interface IMasterTransportUnitControllerForm {
    widthPopUp: any;
    heigthPopUp: any;
}
export const MasterTransportUnitControllerForm: React.FC<IMasterTransportUnitControllerForm> = ({ widthPopUp, heigthPopUp }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });

    const { showPopUp } = useAppSelector((state) => state.masterPopUp);
    const { data } = useAppSelector((state) => state.catalog.transportUnitRemaining);
    const { form, loading } = useAppSelector((state) => state.masterTransportUnitForm);

    const onAcceptPopUp = () => {
        dispatch(postToMasterTransportUnitForm()).then((response: any) => {
            if (response) {
                onCancelPopUp();
            }
        });
    };

    const onCancelPopUp = () => {
        dispatch(setShowPopUpMaster(PopUpCodes.NONE));
    };
    const onDimissed = () => {
        dispatch(resetMasterTransportUnitForm());
    };

    const showNotData = useMemo(() => {
        return !data.length && showPopUp === PopUpCodes.CREATE ? true : false;
    }, [data, showPopUp]);

    const titlePopUp = useMemo(() => {
        let title = "";
        if (showPopUp === PopUpCodes.CREATE) {
            title = t("CREATE") + " " + t("BUTTON.TRANSPORT_UNIT");
        } else if (showPopUp === PopUpCodes.UPDATE) {
            title = t("UPDATE") + " " + t("BUTTON.TRANSPORT_UNIT");
        }
        return title;
    }, [showPopUp]);

    const isDisabledButton = useMemo(() => {
        return validateDefaultForm(form, showPopUp === PopUpCodes.CREATE);
    }, [form]);

    useEffect(() => {
        showPopUp === PopUpCodes.CREATE && dispatch(fetchTransportUnitRemaining());
    }, [showPopUp]);

    return (
        <PopUpForm
            content={
                <MasterSealTypesForm
                    showNotData={showNotData}
                    data={data}
                />
            }
            title={titlePopUp}
            isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE ? true : false}
            onCancel={onCancelPopUp}
            onSave={onAcceptPopUp}
            onDimissed={onDimissed}
            height={heigthPopUp}
            width={widthPopUp}
            onlyHidden={showNotData}
            isDisabledButton={isDisabledButton}
            isLoading={loading}
            leftButtonContent={<RequiredFieldsMessage />}
        />
    );
};
